import { Button, Divider, Group, modals, Paper, SafeHtml, Stack, Text } from "@dutyon/ui-kit";
import dayjs from "dayjs";

interface TermsPreviewContentProps {
  terms: {
    title: string;
    version: string;
    releasedAt: string | Date | null;
    content: string;
    creator?: { name: string } | null;
  };
  modalId: string;
}

export function TermsPreviewContent({ terms, modalId }: TermsPreviewContentProps) {
  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Text size="xs" c="dimmed">
          발행인: {terms.creator?.name || "시스템"} | 릴리즈:{" "}
          {terms.releasedAt ? dayjs(terms.releasedAt).format("YYYY-MM-DD HH:mm") : "임시저장"}
        </Text>
      </Group>
      <Divider />
      <Paper
        withBorder
        p="md"
        radius="md"
        style={{
          maxHeight: 500,
          overflowY: "auto",
          lineHeight: "1.7",
          fontSize: "14px",
        }}
      >
        <SafeHtml html={terms.content} />
      </Paper>
      <Group justify="flex-end" mt="md">
        <Button onClick={() => modals.close(modalId)}>닫기</Button>
      </Group>
    </Stack>
  );
}
